import { CommentInteractionButton } from 'common/InteractionButton/components/CommentInteractionButton/CommentInteractionButton'
import { TaskInteractionButton } from 'common/InteractionButton/components/TaskInteractionButton/TaskInteractionButton'
import { useRootStore } from 'stores/RootStore'
import Styles from '../../CardViewComponent.module.scss'
import { commentAriaLabel, taskAriaLabel } from '../../utils/textUtils'

type InteractionButtonsProps = {
  disabled?: boolean
  comments: Array<string>
  tasks: Array<string>
}

export const InteractionButtons = ({ disabled, comments, tasks }: InteractionButtonsProps) => {
  const rootStore = useRootStore()
  const docStore = rootStore.docStore

  if (!docStore || disabled || (comments.length < 1 && tasks.length < 1)) return null

  return (
    <div className={Styles.interactionButtons}>
      {comments.length > 0 && (
        <CommentInteractionButton docStore={docStore} aria-label={commentAriaLabel} uuids={comments} />
      )}
      {tasks.length > 0 && <TaskInteractionButton docStore={docStore} aria-label={taskAriaLabel} uuids={tasks} />}
    </div>
  )
}
